import type {
  CmmdProviderAccountInventory,
  CmmdProviderAccountInventoryAccount,
} from "@cmmd-forge/contracts";

export function decodeProviderAccounts(value: unknown): CmmdProviderAccountInventory {
  if (!isRecord(value) || !Array.isArray(value.accounts)) {
    throw new Error("CMMD returned invalid provider accounts.");
  }
  const accounts = value.accounts.filter(isProviderAccount);
  return { accounts };
}

function isProviderAccount(value: unknown): value is CmmdProviderAccountInventoryAccount {
  if (!isRecord(value)) return false;
  return (
    isProviderAccountKind(value.provider) &&
    isNonEmptyString(value.providerAccountId) &&
    hasProviderAccountIdentityMetadata(value) &&
    isProviderAccountNullableString(value.accountEmail) &&
    isProviderAccountNullableString(value.accountDisplayName) &&
    isProviderAccountNullableString(value.planType) &&
    typeof value.isDefault === "boolean" &&
    typeof value.needsReconnect === "boolean"
  );
}

function hasProviderAccountIdentityMetadata(value: Record<string, unknown>): boolean {
  return (
    (value.credentialTarget === "primary" || value.credentialTarget === "linked") &&
    Array.isArray(value.legacyProviderAccountIds) &&
    value.legacyProviderAccountIds.every(isNonEmptyString)
  );
}

function isProviderAccountKind(value: unknown): value is "codex" | "claudeAgent" {
  return value === "codex" || value === "claudeAgent";
}

function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}

function isProviderAccountNullableString(value: unknown): value is string | null {
  return typeof value === "string" || value === null;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
